import { t$2 } from '@/js/global/global'
import { shouldAnimate } from '@/js/global/helpers'
import { register } from '@/js/global/shopify-theme-sections'
import { animateMultiColumnYoutube } from '@/js/global/animations'

let loaded = null;
function loadYouTubeAPI() {
  // Loading was triggered by a previous call to function
  if (loaded !== null) return loaded;

  // API has already loaded
  if (window.YT && window.YT.loaded) {
    loaded = Promise.resolve();
    return loaded;
  }

  // Otherwise, load API
  loaded = new Promise(resolve => {
    window.onYouTubeIframeAPIReady = () => {
      resolve();
    };
    const tag = document.createElement("script");
    tag.src = "https://www.youtube.com/iframe_api";
    document.body.appendChild(tag);
  });
  return loaded;
}

const multiColumnYoutubeSelectors = {
  playerContainers: '[data-youtube-player]'
}

register("multi-column-youtube", {
  onLoad() {
    const playerContainers = t$2(multiColumnYoutubeSelectors.playerContainers, this.container);

    if (playerContainers.length > 0) {
      loadYouTubeAPI().then(() => {
        const players = [];

        playerContainers.forEach(playerContainer => {
          const {
            ytVideoId,
            ytPlaylistId
          } = playerContainer.dataset;

          players.push(
            new window.YT.Player(playerContainer, {
              // If there isn't a playlist id, add "videoId" to player options
              ...ytPlaylistId == '' ? {videoId: ytVideoId} : {},
              playerVars: {
                modestbranding: 1,
                playsinline: 0,
                rel: 0,
                loop: 0,

                // If there is a playlist id, add list parameters to player options
                ...ytPlaylistId != '' ? {listType: 'playlist', list: `${ytPlaylistId}`} : {}
              },
              events: {
                onStateChange: (event) => {
                  if (event.data == window.YT.PlayerState.PLAYING) {
                    players.forEach((player) => {
                      if (player.getIframe().id != event.target.getIframe().id) {
                        player.pauseVideo();
                      }
                    });
                  }
                }
              }
            })
          )
        });
      });
    }

    if (shouldAnimate(this.container)) {
      this.animateMultiColumnYoutube = animateMultiColumnYoutube(this.container);
    }
  },

  onUnload() {
    var _this$animateMultiColumnYoutube;
    (_this$animateMultiColumnYoutube = this.animateMultiColumnYoutube) === null || _this$animateMultiColumnYoutube === void 0 ? void 0 : _this$animateMultiColumnYoutube.destroy();
  }
});